export const CREATE_TAX_CONDITION = `
  mutation createTaxCondition($input: CreateTaxConditionInput!, $tenant_id: Int!) {
    createTaxCondition(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on TaxCondition {
        id
        name
        category
        active
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const UPDATE_TAX_CONDITION = `
  mutation updateTaxCondition($input: UpdateTaxConditionInput!, $tenant_id: Int!) {
    updateTaxCondition(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on TaxCondition {
        id
        name
        category
        active
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const DELETE_TAX_CONDITION = `
  mutation deleteTaxCondition($id: Int!, $tenant_id: Int!) {
    deleteTaxCondition(id: $id, tenant_id: $tenant_id) {
      __typename
      ... on TaxCondition {
        id
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
